import { Route, Routes } from "react-router-dom"
import TagList from "./components/TagList"

export default function TagsPage() {
  return (
    <Routes>
      <Route index element={<TagList />} />
      <Route path=":id" element={<TagList />} />
    </Routes>
  )
}
